export const shareAppletDefaultValues = {
  appletName: '',
  keyword: '',
  keywords: [],
  checked: false,
};

export const ERROR_MARGIN_TOP = 0.5;
